import { baseUrl } from 'volto-ebc-radiomec/utils/api';
import { normalizeImageUrl } from 'volto-ebc-radiomec/utils/normalizeImageUrl';
import { normalizeVodUrl } from '../../utils/guessVodUrl';

import type { ProgramItem } from '../../components/shared/ProgramCarouselSection/ProgramCarouselSection.types';

export function normalizeLatestPodcasts(data: unknown): ProgramItem[] {
  const items = Array.isArray(data) ? data : [];

  return items.map((item: any) => ({
    '@id': item?.['@id'] ?? '',
    title: item?.title ?? '',
    description: item?.description ?? '',
    image: normalizeImageUrl(item?.image),
    imageVersion: item?.imageVersion ? String(item.imageVersion) : undefined,
    type_title: item?.programTitle ?? item?.type_title ?? '',
    audio: normalizeVodUrl(item?.audio, item?.['@id']) ?? '',
    effective: item?.effective ?? '',
    programUrl: item?.programUrl ?? '',
    '@type': 'Podcast',
  }));
}

export async function getLatestPodcasts(): Promise<ProgramItem[]> {
  try {
    const response = await fetch(
      `${baseUrl}/@content-latest-podcast-per-program`,
    );

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar podcasts recentes por programa: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    return normalizeLatestPodcasts(data);
  } catch (error) {
    console.error('Falha ao buscar podcasts recentes por programa:', error);
    return [];
  }
}
